// extracted by mini-css-extract-plugin
export var addToCartButton = "_s6-b";
export var arrowButtonContainer = "_s6-9";
export var arrowButtonIcon = "_s6-a";
export var carouselArrowButton = "_s6-6";
export var carouselElementContainer = "_s6-1";
export var left = "_s6-7";
export var productDisplayCarouselContainer = "_s6-0";
export var productTileContainer = "_s6-2";
export var productTileImage = "_s6-4";
export var productTileImageContainer = "_s6-3";
export var productTileTitle = "_s6-5";
export var right = "_s6-8";
export var sliderOverflow = "_s6-c";